import { GraphQlLiteral } from "../../graphQlBuilder/GraphQlLiteral.js";
const whereToFilter = (by) => {
  const where = {};
  for (const key in by) {
    const value = by[key];
    if (value instanceof GraphQlLiteral || typeof value === "string" || typeof value === "number") {
      where[key] = { eq: value };
    } else {
      where[key] = whereToFilter(value);
    }
  }
  return where;
};
export {
  whereToFilter
};
//# sourceMappingURL=whereToFilter.js.map
